import { createSignal } from "solid-js";
import { Form, Row, Col } from "solid-bootstrap";
import { DeviceForm } from "./deviceform";

export function SystemOptions(props) {
    const [myDevice, setMyDevice] = createSignal(props.device);
    const [isSpookyContent, setSpookyContent] = createSignal(props.device.spooky_campaign_opt_in);

    const readFormFields = (formDevice) => {
        const formNicknameField = document.getElementById("device.nickname");
        const formNickname = formNicknameField.value;
        formDevice["nickname"] = formNickname;

        formDevice["spooky_campaign_opt_in"] = isSpookyContent();
    };

    function onChangeSpookyContent(e) {
        setSpookyContent(e.target.checked);
    }

    const nicknameRegex = `^([a-zA-Z0-9_\\-][a-zA-Z0-9 _\\-]*)?[a-zA-Z0-9_\\-]$`;

    return <DeviceForm title="System options" device={props.device} setDevice={setMyDevice} readFormFields={readFormFields} submitText="Save">
        <Row>
            <Col xs={12} md={3}>
                <Form.Group controlId="device.nickname">
                    <Form.Label>Nickname</Form.Label>
                    <Form.Control
                        required
                        type="text"
                        placeholder="nickname"
                        pattern={nicknameRegex}
                        value={myDevice().nickname} />
                    <Form.Control.Feedback type="invalid">Device nickname required</Form.Control.Feedback>
                </Form.Group>
            </Col>
        </Row>

        <h2>Scottish Mycological Society Partnership</h2>
        <Row>
            <Col xs={12} md={6}>
                <p>Timechief is proud to partner with the <a href="https://fungusqueen.blogspot.com/">Scottish Mycological Society</a> through an ongoing program to train science post-graduates in technology skills.  Opt in to this content below:</p>
            </Col>
        </Row>

        <Row>
            <Col xs={12} md={3}>
                <Form.Check
                    type="switch"
                    id="device.spooky_campaign_opt_in"
                    label="Show disturbing content (recommended age 15+)"
                    onChange={onChangeSpookyContent}
                    checked={myDevice().spooky_campaign_opt_in}
                />
            </Col>
        </Row>
    </DeviceForm>
}

